import $ from "jquery";
import config from "../config/localization.json";

/**
 * LocalizationInfo enthält eine Domain-Kofiguration und Sprache im Iso-Code.
 */
class LocalizationInfo {

  /**
   * @param domain Domain-Konguration
   * @param language Sprache als Iso-Code
   */
  constructor (domain, language) {
    this.domain = domain;
    this.language = language;
  }
}

/**
 * Lokalisiert die HTML anhand der übergebenen Sprache.
 * @param lang  Sprache als Iso-Code (z.B. "de")
 * @param brand Brand-Kürzel aus domain, falls vorhanden.
 */
const localizeHTMLTemplateText = (lang, brand) => {
  // Lokalisierte Werte über den Schlüssel im Dom suchen und ersetzen
  Object.keys(config.localization.default[lang]).forEach((key) => {
    const textElement = $("#tmpl-lang-" + key)
    if (brand && config.localization[brand][lang][key]) {
      // Brand spezifische Lokalisierung verwenden.
      textElement.html(config.localization[brand][lang][key]);
    } else {
      // Standard Lokalisierung verwenden
      textElement.html(config.localization.default[lang][key]);
    }
  });
};

/**
 * Anzeigen von möglichen Social-Media-Icons.
 *
 * @param domain Domain-Konfiguration in der Konfigurationsdatei
 * @param lang  Sprache als Iso-Code (z.B. "de")
 */
const localizeHTMLTemplateSocialMediaIcons = (domain, lang) => {
  const socialMediaLinks = domain.socialLinks[lang];
  const socialMediaLinksDom = $("#tmpl-socialBar");
  for (const socialMediaLink of socialMediaLinks) {
    const socialMediaLinkDom = socialMediaLinksDom.find("#tmpl-socialBar-" + socialMediaLink.icon);
    socialMediaLinkDom.attr("href", socialMediaLink.url);
    socialMediaLinkDom.removeClass("d-none");
  }
  if (socialMediaLinks.length > 0) {
    showSocialbar();
  }
};

/**
 * Anzeigen von möglichen ExternenLinks im Social-Media-Bereich (z.B. Magazin).
 *
 * @param domain Domain-Konfiguration in der Konfigurationsdatei
 * @param _lang  Sprache als Iso-Code (z.B. "de")
 */
const localizeHTMLTemplateExternalLinks = (domain, _lang) => {
  const externalLinks = domain.externalLinks;
  const $externalLinksDom = $("#tmpl-externalLinks");
  const $externalLinksDomTemplate = $("#tmpl-externalLink-template");
  for (const externalLink of externalLinks) {
    const $externalLinkDom = $($externalLinksDomTemplate.get(0).content.cloneNode(true));
    $externalLinkDom.find("a").attr("href", externalLink.url).text(externalLink.name);
    $externalLinkDom.appendTo($externalLinksDom);
  }
  if (externalLinks.length > 0) {
    showSocialbar();
  }
};

/**
 * Den Bereich für Social-Media-Links anzeigen.
 */
const showSocialbar = () => {
  $("#tmpl-socialBar").removeClass("d-none");
};

/**
 * Liefert die Domain-Konfiguration anhander der aufgerufenen Domain und liefert die Sprache zur Domain.
 * Bei der Sprache werden die Sprachpräferenzen des Browsers beachtet.
 *
 * @returns {LocalizationInfo}
 *          Enthält die Domain-Definitionen aus Konfiguration und Sprache als einfacher ISO-Code
 */
const getLocalizationInfo = () => {
  const domain = getCurrentPageDomain();
  const language = getPreferredLanguage(domain);
  return new LocalizationInfo(domain, language);
};

/**
 * Liefert die passende Domain-Konfiguration zur angezeigten Seite anhand das Hostnames oder den Fallback.
 *
 * @returns {Object}
 *          Domain-Konfiguration
 */
const getCurrentPageDomain = () => {
  const domainKey = Object.keys(config.domains).find((_domainKey) => { return getHostname().includes(_domainKey);});
  const domain = config.domains[domainKey];
  return domain ? domain : config.domains[config.defaults.domainKey];
};

/**
 * Liefert den Hostname der aktuell aufgerufenen Webseite.
 *
 * @returns {string}
 *          Hostname
 */
const getHostname = () => {
  return window.location.hostname;
};

/**
 * Liefert den Iso-Code der am besten passende Sprache der übergebenen Domain-Konfigurationen oder den Fallback.
 * Dabei wird die Sprach-Präferenz beachtet.
 *
 * @param domain
 *        Domain-Konfiguration
 * @returns {string}
 *          Iso-Code der am besten passende Sprache
 */
const getPreferredLanguage = (domain) => {
  const language = navigator.languages.find((browserLang) => {
    // Sprache auf ISO-639-1 begrenzen (z.B. de-DE -> de)
    const lang = browserLang.substring(0, 2);
    return domain.languages.includes(lang);
  });
  return language ? language.substring(0, 2) : domain.defaultLanguage;
};

/**
 * Ausführung im Browser...
 */
$(() => {

  // Domain und Sprache feststellen
  const localizationInfo = getLocalizationInfo();

  // Texte im HTML anpassen
  localizeHTMLTemplateText(localizationInfo.language, localizationInfo.domain.brand);

  // Social-Media Icons und dessen Links anpassen
  localizeHTMLTemplateSocialMediaIcons(localizationInfo.domain, localizationInfo.language);

  // Zusätzliche Links anpassen
  localizeHTMLTemplateExternalLinks(localizationInfo.domain, localizationInfo.language);
});
